export default __webpack_public_path__ + "static/media/hotline_gif.b98b066a.gif";